<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const inboxDisplayName = computed(() => {
  const rawInboxName = String(props.inbox?.name || '').trim();
  if (!rawInboxName) return '';

  const sanitizedInboxName = rawInboxName.replace(/^CWT[\s\-:_]*/i, '').trim();
  return sanitizedInboxName || rawInboxName;
});
</script>

<template>
  <div class="flex items-center text-n-slate-11 text-xs min-w-0">
    <ChannelIcon
      :inbox="inbox"
      class="size-3 ltr:mr-1 rtl:ml-1 flex-shrink-0"
    />
    <span class="truncate">
      {{ inboxDisplayName }}
    </span>
  </div>
</template>
